module.exports = __webpack_public_path__ + "img/BrandMe_IA_MujerCoachella_7.3701a7f9.png";